import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getCurrencySign, toggleModal } from "../store/common";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { productImagePath } from "../utils/product.util";
import { getTranslate, getActiveLanguage } from "react-localize-redux";
import html from "react-inner-html";
import ProductDetailContainer from "../routes/ProductDetail/containers/ProductDetailContainer";
import OrderDetailContainer from "../routes/OrderDetail/containers/OrderDetailContainer";
import { getOrderDetail } from "../store/order";
import CompanySection from "../molecules/components/CompanySection";
import UserPersonalSection from "../molecules/components/UserPersonalSection";

import CartListItem from "../routes/CartList/components/CartListItem";
import MoveBtn from "../molecules/components/MoveBtn";
import ActionBtn from "../molecules/components/ActionBtn";
import SummaryPrice from "../molecules/components/SummaryPrice";
import MediaQuery from "react-responsive";

const OrderModalContainer = ({
  toggleModal,
  orderData,
  currencySign,
  isOpen,
  translate,
  currentLanguage
}) => (
    <Modal
      size="lg"
      className="order_modal"

      isOpen={isOpen}
      toggle={() => toggleModal("order_modal", false)}
      centered={true}
    >
      <ModalHeader>
        {" "}
        <h1>
          {orderData && orderData.order_number}
        </h1>
      </ModalHeader>
      <ModalBody>
        {orderData && (
          <React.Fragment>
            <div className="container mt-3 mb-3">
              <div className="row">
                <div className="col-12 col-md-6 bg-light pt-4 pb-4">
                  {orderData.user &&
                    orderData.user.personal ? (
                      <UserPersonalSection
                        title="Personal information"
                        data={orderData.user}
                      />
                    ) : (
                      ""
                    )}
                </div>
                <div className="col-12 col-md-6 bg-light pt-4 pb-4">
                  {orderData.user &&
                    orderData.user.company ? (
                      <CompanySection
                        title="Company detail"
                        data={orderData.user.company}
                      />
                    ) : (
                      ""
                    )}
                </div>
              </div>
            </div>

            <div className="container mt-3 mb-3 bg-light">
              <div className="row">
                <div className="col-12">
                  <h4>Note</h4>
                </div>
                <div className="col-12">{orderData.note}</div>
              </div>
            </div>

            <div className="container mt-3 mb-3">
              {orderData.products
                ? orderData.products.map(orderProduct => (
                  <CartListItem
                    key={orderProduct.id}
                    cartProduct={orderProduct}
                    isSelected={false}
                    selectCartProduct={null}
                    deleteCartProduct={null}
                    enableToManipulate={false}
                    currencySign={currencySign}
                    labelQuantity={translate(
                      "routes.cartList.cartListItem.quantity"
                    )}
                    labelDiscount={translate(
                      "routes.cartList.cartListItem.discount"
                    )}
                    labelPrice={translate(
                      "routes.cartList.cartListItem.price"
                    )}
                    labelTotal={translate(
                      "molecules.components.summaryPrice.total_msg"
                    )}
                  />
                ))
                : "still loading"}

              <SummaryPrice
                totalExclVat={orderData.totalExcludedVatPrice}
                vat={orderData.vat}
                shipping={orderData.shippingCost}
                total={orderData.totalPrice}
                currencySign={currencySign}
                totalVatMsg={translate(
                  "molecules.components.summaryPrice.total_vat_msg"
                )}
                shippingMsg={translate(
                  "molecules.components.summaryPrice.shipping_msg"
                )}
                vatMsg={translate(
                  "molecules.components.summaryPrice.vat_msg"
                )}
                totalMsg={translate(
                  "molecules.components.summaryPrice.total_msg"
                )}
              />
            </div>
          </React.Fragment>)}
      </ModalBody>
      <ModalFooter>
        <Button
          color="btn btn-secondary btn-danger"
          onClick={() => toggleModal("order_modal", false)}
        >
          {translate("containers.productModalContainer.close")}
        </Button>
      </ModalFooter>
    </Modal>
  );

const mapStateToProps = state => ({
  translate: getTranslate(state.locale),
  currentLanguage: getActiveLanguage(state.locale).id || 1,
  orderData: getOrderDetail(state.order.detail),
  currencySign: getCurrencySign(state.common.user.currency.sign),
  isOpen: state.common.modals.order_modal
});

const mapDispatchToProps = dispatch => ({
  toggleModal: (modalName, action) => dispatch(toggleModal(modalName, action))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OrderModalContainer);



// WEBPACK FOOTER //
// ./src/containers/OrderModal.js